import * as React from 'react';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from 'shared/utils/hooks/useRedux';
import { useFormRedux } from "shared/utils/hooks/useFormRedux";
import { updateField } from 'entities/mite-policy/step-2';
import { getValidationSchema, insuredValidationSchema, validationSchema, validationSchemaInsurance } from 'entities/mite-policy/step-2/utils/validationSchema';
import { useEffect, useRef, useState } from 'react';
import { IStepTwo } from 'entities/mite-policy/step-2/types/step-two-inerface';
import * as yup from 'yup';

import { PolicyholderStep } from './ui/PolicyholderStep';
import { InsuredStep } from './ui/InsuredStep';
import { InsuranceTermStep } from './ui/InsuranceTermStep';
import { FieldValidationStep } from './ui/FieldValidationStep';
import { FormFieldsStepOne } from 'entities/mite-policy/step-1/selector';
import { getRequest } from 'shared/utils/fetch-api';
import { ProductID, SellerID } from 'entities/main-page/selector';

enum Steps {
    Policyholder = "Policyholder",
    Insured = "Insured",
    InsuranceTerm = "InsuranceTerm",
    FieldValidation = "FieldValidation",
}

interface StepTwoProps {
    handleNext: () => void;
    windowWidth: number;
}

export const StepTwo: React.FC<StepTwoProps> = ({ handleNext, windowWidth }) => {

    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

    const [currentStep, setCurrentStep] = useState<Steps>(Steps.Policyholder);
    const [errors, setErrors] = useState<Record<string, string>>({});

    const [requestProps, setRequestProps] = useState<boolean>(false);

    const sellerID = useAppSelector(SellerID);
    const productID = useAppSelector(ProductID);

    const getRequestPropsMethod = async () => {
        try {
            const response = await getRequest({ sellerId: sellerID }, 'max-bot', 'getProps', 'POST');
            const result = await response.json();
            setRequestProps(result.Data.needClientId);
        } catch (error) {
            console.error('Ошибка:', error);
        }
    }

    useEffect(() => {
        getRequestPropsMethod();
    }, [])

    const dispatch = useAppDispatch();

    const fieldsStepOne = useAppSelector(FormFieldsStepOne);

    const {
        formState,
        handleChange,
        handleBlur,
        handleDateChange,
        formatPhone,
        handleCheckboxChange,
        handleUpdateArrayItem,
        handleRemoveArrayItem,
        handleAddArrayItem,
        handleToggleGenderChange,
        handleToggleInsuredGenderChange,
        handlePhoneChange
    } = useFormRedux(
        (state) => state.stepTwo,
        updateField,
        validationSchema
    );
    const wrappedHandleCheckboxChange = (fieldName: keyof IStepTwo) =>
        (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
            handleCheckboxChange(fieldName)(e, checked);
        };

    useEffect(() => {
        const newInsured = {
            Fio: '',
            LastName: '',
            FirstName: '',
            MiddleName: '',
            BirthDate: '',
            Gender: '',
        };
        const updatedInsuredList = Array(fieldsStepOne.InsuranceCount).fill(newInsured)

        dispatch(updateField({ field: 'InsuredList', value: updatedInsuredList }));
    }, [fieldsStepOne.InsuranceCount])
    useEffect(() => {
        if (currentStep === Steps.Insured && formState.PolicyholderIsSame) {
            const newInsured = {
                Fio: formState.Fio,
                LastName: formState.LastName,
                FirstName: formState.FirstName,
                MiddleName: formState.MiddleName,
                BirthDate: formState.BirthDate,
                Gender: formState.Gender,
            };
            const updatedInsuredList = [newInsured, ...formState.InsuredList.slice(1)];
            dispatch(updateField({ field: 'InsuredList', value: updatedInsuredList }));
        }
    }, [currentStep]);
    useEffect(() => {
        if (currentStep !== Steps.Insured) return;

        const newInsured = {
            Fio: formState.Fio,
            LastName: formState.LastName,
            FirstName: formState.FirstName,
            MiddleName: formState.MiddleName,
            BirthDate: formState.BirthDate,
            Gender: formState.Gender,
        };

        if (formState.PolicyholderIsSame) {
            const updatedInsuredList = [newInsured, ...formState.InsuredList.slice(1)];
            dispatch(updateField({ field: 'InsuredList', value: updatedInsuredList }));
        } else {
            const emptyInsured = {
                Fio: '',
                LastName: '',
                FirstName: '',
                MiddleName: '',
                BirthDate: '',
                Gender: '',
            };
            const updatedInsuredList = [emptyInsured, ...formState.InsuredList.slice(1)];
            dispatch(updateField({ field: 'InsuredList', value: updatedInsuredList }));
        }
    }, [formState.PolicyholderIsSame]);



    useEffect(() => {
        dispatch(updateField({ field: 'projectId', value: fieldsStepOne.Uid }));
        dispatch(updateField({ field: 'sellerId', value: sellerID }));
        dispatch(updateField({ field: 'regionId', value: fieldsStepOne.City }));
        dispatch(updateField({ field: 'productId', value: productID }));
    }, [])

    const emailDomains = [
        'gmail.com',
        'yandex.ru',
        'mail.ru',
        'rambler.ru',
        'yahoo.com',
        'outlook.com',
        'icloud.com',
        'bk.ru',
        'inbox.ru',
        'list.ru',
    ];

    const [emailInput, setEmailInput] = useState(formState.Email);
    const [expandedPanel, setExpandedPanel] = useState<number | false>(false);

    useEffect(() => {
        setEmailInput(formState.Email);
    }, [formState.Email]);

    const handleEmailInputChange = (event: React.ChangeEvent<{}>, newValue: string) => {
        setEmailInput(newValue);
        dispatch(updateField({ field: 'Email', value: newValue }));
    };

    const handleDomainSelect = (event: React.ChangeEvent<{}>, newValue: string | null) => {
        if (newValue) {
            const [localPart] = emailInput.split('@');
            const newEmail = `${localPart}@${newValue}`;
            setEmailInput(newEmail);
            dispatch(updateField({ field: 'Email', value: newEmail }));
        }
    };

    const filterDomains = (options: string[], state: { inputValue: string }) => {
        const inputValue = state.inputValue.trim();
        if (!inputValue.includes('@')) {
            return [];
        }
        const domainPart = inputValue.split('@')[1] || '';
        return options.filter(option =>
            option.toLowerCase().includes(domainPart.toLowerCase())
        );
    };

    const handleChangeAccordion = (panel: number) => (_: React.SyntheticEvent, isExpanded: boolean) => {
        setExpandedPanel(isExpanded ? panel : false);
    };

    const handleUpdateInsuredField = (index: number, field: keyof IStepTwo['InsuredList'][0]) =>
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value;
            handleUpdateArrayItem('InsuredList', index, { [field]: value });
        };

    const handleUpdateInsuredDate = (index: number) => (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value.replace(/\D/g, '');
        let formattedValue = '';
        if (value.length > 0) {
            formattedValue += value.substring(0, 2);
        }
        if (value.length > 2) {
            formattedValue += '.' + value.substring(2, 4);
        }
        if (value.length > 4) {
            formattedValue += '.' + value.substring(4, 8);
        }
        handleUpdateArrayItem('InsuredList', index, { BirthDate: formattedValue });
    };

    const handleParseInsuredFIO = (index: number, fio: string) => {
        const fioArray = fio.split(' ');
        handleUpdateArrayItem('InsuredList', index, {
            LastName: fioArray[0] || '',
            FirstName: fioArray[1] || '',
            MiddleName: fioArray[2] || '',
        });
    };

    const validatePolicyholderStep = async () => {
        try {
            const schema = getValidationSchema(requestProps);

            await schema.validate(formState, { abortEarly: false });
            setErrors({});
            return true;
        } catch (err) {
            if (err instanceof yup.ValidationError) {
                const newErrors: Record<string, string> = {};
                err.inner.forEach((error) => {
                    if (error.path) {
                        newErrors[error.path] = error.message;
                    }
                });
                setErrors(newErrors);
                return false;
            }
            return false;
        }
    };
    const hasDuplicateInsured = (insuredList: Array<{ Fio: string; BirthDate: string }>): boolean => {
        const seen = new Set<string>();
        return insuredList.some((item) => {
            const key = `${item.Fio}-${item.BirthDate}`;
            if (seen.has(key)) {
                return true;
            }
            seen.add(key);
            return false;
        });
    };
    const validateInsuredStep = async () => {
        try {
            if (hasDuplicateInsured(formState.InsuredList)) {
                setErrors({
                    InsuredListDuplicate: 'В списке застрахованных есть дубли. Пожалуйста, проверьте правильность заполнения ФИО и даты рождения.'
                });
                return false;
            }
            const schema = insuredValidationSchema;
            await schema.validate({ InsuredList: formState.InsuredList }, { abortEarly: false });
            setErrors({});
            return true;
        } catch (err) {
            if (err instanceof yup.ValidationError) {
                const newErrors: Record<string, string> = {};
                err.inner.forEach((error) => {
                    if (error.path) {
                        newErrors[error.path] = error.message;
                    }
                });
                setErrors(newErrors);
                return false;
            }
            return false;
        }
    };
    const validateInsuranceTermStep = async () => {
        try {
            const schema = yup.object().shape({
                BeginDate: yup.string().required('Обязательное поле'),
                AgreePolitics: yup.boolean().oneOf([true], 'Необходимо согласие на обработку персональных данных'),
                AgreeAd: yup.boolean(),
            });

            await schema.validate(formState, { abortEarly: false });
            setErrors({});
            return true;
        } catch (err) {
            if (err instanceof yup.ValidationError) {
                const newErrors: Record<string, string> = {};
                err.inner.forEach((error) => {
                    if (error.path) {
                        newErrors[error.path] = error.message;
                    }
                });
                setErrors(newErrors);
                return false;
            }
            return false;
        }
    };
    const handleNextStep = async () => {
        let isValid = false;
        switch (currentStep) {
            case Steps.Policyholder:
                isValid = await validatePolicyholderStep();
                if (isValid) setCurrentStep(Steps.Insured);
                break;
            case Steps.Insured:
                setIsSubmitted(true);
                isValid = await validateInsuredStep();
                if (isValid) setCurrentStep(Steps.InsuranceTerm);
                break;
            case Steps.InsuranceTerm:
                isValid = await validateInsuranceTermStep();
                if (isValid) setCurrentStep(Steps.FieldValidation);
                break;
            case Steps.FieldValidation:
                break;
            default:
                break;
        }
    };

    const handleBack = () => {
        switch (currentStep) {
            case Steps.Insured:
                setCurrentStep(Steps.Policyholder);
                break;
            case Steps.InsuranceTerm:
                setCurrentStep(Steps.Insured);
                break;
            case Steps.FieldValidation:
                setCurrentStep(Steps.InsuranceTerm);
                break;
            default:
                break;
        }
    };

    const [openDatePicker, setOpenDatePicker] = useState<boolean>(false);

    useEffect(() => {
        if (formState.BeginDate) {
            const [day, month, year] = formState.BeginDate.split('.').map(Number);
            const beginDate = new Date(year, month - 1, day);
            beginDate.setFullYear(beginDate.getFullYear() + 1);
            beginDate.setDate(beginDate.getDate() - 1);
            const formattedDate = [
                String(beginDate.getDate()).padStart(2, '0'),
                String(beginDate.getMonth() + 1).padStart(2, '0'),
                beginDate.getFullYear()
            ].join('.');
            dispatch(updateField({ field: 'EndDate', value: formattedDate }));
        }
    }, [formState.BeginDate]);

    const wrappedHandleBlur = (fieldName: keyof IStepTwo) => (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const inputEvent = e as React.FocusEvent<HTMLInputElement>;
        handleBlur(fieldName)(inputEvent);
    };

    return (
        <Box>
            <form id='step-two'>
                {currentStep === Steps.Policyholder && (
                    <PolicyholderStep
                        formState={formState}
                        errors={errors}
                        handleChange={handleChange}
                        handleBlur={wrappedHandleBlur}
                        handleDateChange={handleDateChange}
                        formatPhone={formatPhone}
                        handleCheckboxChange={handleCheckboxChange}
                        handleToggleGenderChange={handleToggleGenderChange}
                        handleNextStep={handleNextStep}
                        emailInput={emailInput}
                        handleEmailInputChange={handleEmailInputChange}
                        handleDomainSelect={handleDomainSelect}
                        filterDomains={filterDomains}
                        emailDomains={emailDomains}
                        requestProps={requestProps}
                        windowWidth={windowWidth}
                        handlePhoneChange={handlePhoneChange}
                    />
                )}
                {currentStep === Steps.Insured && (
                    <InsuredStep
                        formState={formState}
                        errors={errors}
                        handleUpdateArrayItem={handleUpdateArrayItem}
                        handleRemoveArrayItem={handleRemoveArrayItem}
                        handleAddArrayItem={handleAddArrayItem}
                        handleNextStep={handleNextStep}
                        handleBack={handleBack}
                        expandedPanel={expandedPanel}
                        handleChangeAccordion={handleChangeAccordion}
                        handleUpdateInsuredField={handleUpdateInsuredField}
                        handleUpdateInsuredDate={handleUpdateInsuredDate}
                        handleParseInsuredFIO={handleParseInsuredFIO}
                        handleToggleInsuredGenderChange={handleToggleInsuredGenderChange}
                        handleCheckboxChange={wrappedHandleCheckboxChange}
                        isSubmitted={isSubmitted}
                    />
                )}
                {currentStep === Steps.InsuranceTerm && (
                    <InsuranceTermStep
                        formState={formState}
                        errors={errors}
                        handleChange={handleChange}
                        handleCheckboxChange={handleCheckboxChange}
                        handleNextStep={handleNextStep}
                        handleBack={handleBack}
                        openDatePicker={openDatePicker}
                        setOpenDatePicker={setOpenDatePicker}
                    />
                )}
                {currentStep === Steps.FieldValidation && (
                    <FieldValidationStep
                        formState={formState}
                        formatPhone={formatPhone}
                        handleNext={handleNext}
                        handleBack={handleBack}
                        windowWidth={windowWidth}
                    />
                )}
            </form>
        </Box>
    );
};
